/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Teal_Wolf_DrawInputs */

const en_swift_teal_wolf_draw = /** @type {(inputs: Swift_Teal_Wolf_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

const de_swift_teal_wolf_draw = /** @type {(inputs: Swift_Teal_Wolf_DrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Swift_Teal_Wolf_DrawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const swift_teal_wolf_draw = /** @type {((inputs?: Swift_Teal_Wolf_DrawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Teal_Wolf_DrawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_swift_teal_wolf_draw(inputs)
	return de_swift_teal_wolf_draw(inputs)
});